<div class="govuk-width-container">
    <div class="row ">
        <nav class="col-12 col-md-4" aria-label="Side navigation">
            <p class="govuk-body h-100"><app-menu></app-menu></p>
        </nav>
        <main class="govuk-main-wrapper col-12 col-md-8 pt-0" id="main-content" tabindex="-1">
            <div *ngIf="formData">
                <h1 class="govuk-heading-xl">Ceremony Choices</h1>
                <app-custom-object-banner page="ceremony-choices"></app-custom-object-banner>
                <ng-container *ngIf="locked">
                    <div class="govuk-notification-banner app-notification-banner" role="region" aria-labelledby="govuk-notification-banner-title" data-module="govuk-notification-banner">
                        <div class="govuk-notification-banner__header">
                            <h2 class="govuk-notification-banner__title" id="govuk-notification-banner-title">
                            Important information
                            </h2>
                        </div>
                        <div class="govuk-notification-banner__content">
                            <p class="govuk-notification-banner__heading" [innerHTML]="lockedMessage"></p>
                        </div>
                    </div>
                </ng-container>
                <app-form-builder [formId]="ceremony_choices" [formData]="formData" [booking]="booking"
                    [attachedFiles]="attachedFiles" [deletedFiles]="deletedFiles" (formStatus)="formStatus($event)"
                    (fileStatus)="fileStatus($event)" [uploadSuccess]="uploadSuccess"></app-form-builder>
                <button [disabled]="!canSubmit || locked" type="submit" data-prevent-double-click="true" class="btn btn-primary"
                        (click)="saveForm()">
                    Save
                </button>
                <div *ngIf="this.saved" class="govuk-hint" role="alert" aria-live="assertive">
                    <br>
                  <p>Thank you for submitting your ceremony choices.</p>
                </div>
            </div>
        </main>
    </div>
</div>
